module.exports = __webpack_public_path__ + "static/img/pccamerabtn.e1f1b13f.svg";